import React from 'react';

export class DeptMicStyleNum extends React.Component {
  render() {
    var contentData = this.props.contentData,
      dept = contentData.dept,
      mic = contentData.mic,
      style = contentData.style;

    return (
      <div>
        {dept && mic && style ? (
          <span className='dept-mic-style'>
            DMS: {dept} {mic} {style}
          </span>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default DeptMicStyleNum;
